import { render, staticRenderFns } from "./SmallCloserIcon.vue?vue&type=template&id=0b0b1ac0&"
import script from "./SmallCloserIcon.vue?vue&type=script&lang=js&"
export * from "./SmallCloserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports